export function getClassName(customClassName: string, existingClassName: string | undefined): string {
	if (existingClassName) {
		return `${customClassName} ${existingClassName}`;
	}
	return customClassName;
}